export const icon = 'block-question'
export const humanName = {
  singular: 'Quiz',
  plural: 'Quizzes'
}
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/quizzes'
  const apiBasePath = `/user/digital_products/${digitalProductId}/quizzes`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    pagination: {
      per_page: 999
    },
    sort: {
      field: 'position',
      order: 'asc'
    },
    getBreadcrumbs
  }

  return config
}
